import { initializeApp } from "firebase/app";
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDNqWOOESEdaZcoz5_V96OtpF6Ygi8CsWQ",
  authDomain: "ppai-81ef9.firebaseapp.com",
  databaseURL: "https://ppai-81ef9-default-rtdb.firebaseio.com",
  projectId: "ppai-81ef9",
  storageBucket: "ppai-81ef9.firebasestorage.app",
  messagingSenderId: "90195085831",
  appId: "1:90195085831:web:befd437f2ca85819b42c3a",
  measurementId: "G-J2QKQ3THRG"
};

// Initialize Firebase
console.log('[FIREBASE] Initializing Firebase with config:', { ...firebaseConfig, apiKey: '***' });
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const functions = getFunctions(app);
const auth = getAuth(app);

// Enable emulators in development
if (process.env.NODE_ENV === 'development') {
  console.log('[FIREBASE] Development mode detected, connecting to emulators...');
  try {
    connectDatabaseEmulator(database, 'localhost', 9030);
    connectFunctionsEmulator(functions, 'localhost', 5001);
    connectAuthEmulator(auth, 'http://localhost:9099');
    console.log('[FIREBASE] Successfully connected to emulators');
  } catch (error) {
    console.error('[FIREBASE] Failed to connect to emulators:', error);
  }
} else {
  console.log('[FIREBASE] Production mode detected, using live Firebase');
}

export { database, functions, auth };